{
  "longPressMessage": "Натиснете продължително или натиснете Alt+ стрелка надолу, за да отворите менюто"
}
